import { useEffect, useCallback, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import ToggleButton from 'react-toggle-button';
import ModalComponent from '../modules/modals/EstimatedPriceModal';

import {
   GetDesCities,
   GetGeneralCites,
   GetGeneralUser,
   GetUserStates,
   PostEstimate,
} from '../../store/actions/kalapost';
import { errorMessage } from '../../utils/message';
import { toEnglishNumbers } from '../../utils/datePicker';
import { canTypeForNumInput } from '../../utils/numbers';

const EstimatedPrice = () => {
   const { executeRecaptcha } = useGoogleReCaptcha();

   const [predata, setPredata] = useState({});
   const [stateOrigin, setStateOrigin] = useState(''); // استان مبدا
   const [citiesId, setCitiesId] = useState({ origin: '', destination: '' }); // شهر مبدا و مقصد
   const [citiesDes, setCitiesDes] = useState([]); // لیست استانهای مقصد
   const [delivery, setDelivery] = useState(''); // نوع تحویل
   const [assu, setAssu] = useState({ stat: false, value: null }); // بیمه شود
   const [title, setTitle] = useState(''); // عنوان
   const [typeAndSize, setTypeAndSize] = useState({}); // نوع
   const [number, setNumber] = useState(null); // تعداد
   const [isFragile, setIsFragile] = useState(false); // شکستنی
   const [type, setType] = useState(''); // اقلام بسته بندی / نوع
   const [count, setCount] = useState(null); // اقلام بسته بندی / تعداد

   const [locations, setLocations] = useState([]);

   const [packes, setPackes] = useState([]);
   const [packing, setPacking] = useState([]);
   const [statesDes, setStatesDes] = useState([]);

   const [weight, setWeight] = useState(null);
   const [typeName, setTypeName] = useState('');
   const [estimateInfo, setEstimateInfo] = useState({
      price: null,
      success: false,
   });

   const styles = {
      thumbStyle: {
         width: '25px',
         height: '25px',
      },
      trackStyle: {
         width: '45px',
         height: '15px',
      },
   };

   // const validator = useRef(
   //   new SimpleReactValidator({
   //     messages: {
   //       required: "پر کردن این فیلد الزامی میباشد",
   //       min: "کمتر از 2 حرف نمی تواند باشد",
   //     },
   //     validators: {
   //       descValid: {
   //         message: "توضیحات معتبر نیستند",
   //         rule: (val) => {
   //           const add = isPersianWithNumber(val);
   //           return add;
   //         },
   //         required: true,
   //       },
   //       titleValid: {
   //         message: "عنوان معتبر نیستند",
   //         rule: (val) => {
   //           const add = isPersianWithNumber(val);
   //           return add;
   //         },
   //         required: true,
   //       },
   //     },
   //     element: (message) => (
   //       <div style={{ color: "red", fontSize: "1.2rem" }}>{message}</div>
   //     ),
   //   })
   // );

   useEffect(() => {
      const handleUser = async () => {
         const res = await GetGeneralUser('price');
         res.status && setPredata(res.data);
      };
      handleUser();
   }, []);

   const handleChangeState = async (e) => {
      setStateOrigin(e.target.value);
      const res = await GetGeneralCites(e.target.value);
      res.status && setLocations(res.data);
   };
   const handleGetStates = async (e) => {
      setCitiesId({ ...citiesId, origin: e.target.value });
      const token = await handleReCaptchaVerify();
      const res = await GetUserStates(stateOrigin, token);
      res.status && setStatesDes(res.data);
   };
   const handleGetCityes = async (e) => {
      const token = await handleReCaptchaVerify();
      const res = await GetDesCities(e.target.value, token);
      res.status && setCitiesDes(res.data);
   };
   const handleChangeType = (e) => {
      const filterSize = predata.packSizePackages.filter(
         (item) => item.title === e.target.value
      )[0];
      setTypeAndSize({
         id: filterSize.id,
         title: e.target.value,
         size: {
            height: filterSize.height,
            length: filterSize.length,
            width: filterSize.width,
         },
      });
   };
   const handleAdd = () => {
      if (number && weight && title && typeAndSize) {
         const found = packes.findIndex(
            (item) =>
               item.typeAndSize.id == typeAndSize.id &&
               item.weight == weight &&
               item.title == title &&
               item.isFragile == isFragile
         );
         if (found === -1) {
            setPackes([
               ...packes,
               {
                  typeAndSize: { ...typeAndSize },
                  weight: parseFloat(weight),
                  number: parseFloat(number),
                  isFragile,
                  title,
               },
            ]);
         } else {
            const arrayPackagesUpdate = [...packes];
            for (let j = 0; j < arrayPackagesUpdate.length; j++) {
               if (j === found) {
                  arrayPackagesUpdate[found].number =
                     +arrayPackagesUpdate[found].number + parseFloat(number);
               }
               setPackes(arrayPackagesUpdate);
            }
         }
         setNumber(null);
         setWeight(null);
         setTitle('');
         setType('');
         setTypeAndSize({});
      } else {
         errorMessage('لطفا اطلاعات مورد نیاز را تکمیل نمایید.');
      }
   };
   const handleDelete = (type, id) => {
      switch (type) {
         case 'goodsInfo':
            const updateRegisterArray = packes.filter((pack, index) => index !== id);
            return setPackes(updateRegisterArray);
         case 'equipment':
            const finalPacking = packing.filter((packing, index) => index !== id);
            return setPacking(finalPacking);
         default:
            return '';
      }
   };
   const handlePacking = () => {
      if (type === null && count === null) {
         errorMessage('مقادیر خواسته شده در اقلام را پر کنید');
         return;
      } else {
         if (type) {
            const found = packing.findIndex((item) => item.type === type);
            if (found === -1) {
               setPacking([
                  ...packing,
                  {
                     count: parseFloat(count),
                     type,
                     typeName,
                  },
               ]);
               setCount('');
               setType('');
            } else {
               const arrayPackagesUpdate = [...packing];
               for (let j = 0; j < arrayPackagesUpdate.length; j++) {
                  if (j === found) {
                     arrayPackagesUpdate[found].count =
                        +arrayPackagesUpdate[found].count + parseFloat(count);
                  }
                  setPacking(arrayPackagesUpdate);
                  setCount('');
                  setType('');
               }
            }
         }
      }
   };
   const handleInquiry = async () => {
      const token = await handleReCaptchaVerify();
      if ((citiesId.origin === '' && citiesId.destination === '') || delivery === '') {
         errorMessage('شهر مبدا و مقصد را انتخاب کنید');
      } else {
         const res = await PostEstimate(
            packes,
            packing,
            Number(citiesId.origin),
            Number(citiesId.destination),
            delivery,
            assu,
            token
         );
         res.status && setEstimateInfo({ price: res.data.price, success: true });
      }
   };
   const handlePackingType = (e) => {
      setType(Number(e.target.value));
      const { title } = predata.packSizePackages.filter(
         (item) => item.id === Number(e.target.value)
      )[0];
      setTypeName(title);
   };

   const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) {
         return;
      }

      const token = await executeRecaptcha();
      return token;
   }, [executeRecaptcha]);

   return (
      <>
         {estimateInfo.success && (
            <ModalComponent estimateInfo={estimateInfo} setEstimateInfo={setEstimateInfo} />
         )}
         <main className='estimate'>
            <div className='estimate__title'>
               <h2>برآورد قیمت</h2>
               <p>
                  در این قسمت شما می توانید بدون ثبت نام در سایت با توجه به مقادیر خواسته شده هزینه
                  ارسال کالای خود را استعلام بگیرید
               </p>
            </div>
            <div className='estimate__container'>
               <div className='estimate__info'>
                  <div className='estimate__locataion'>
                     {/* مبدا  */}
                     <label className='estimate__locataion-labels'>
                        <p className='estimate__locataion-title'>مبدا</p>
                        <label className='estimate__locataion-label'>
                           <p className='estimate__locataion-text'>استان</p>
                           <select
                              className='estimate__locataion-select'
                              name='state'
                              value={stateOrigin}
                              onChange={handleChangeState}
                           >
                              {/* <option value="" selected hidden> */}
                              <option hidden>انتخاب...</option>
                              {predata.states?.map((item) => (
                                 <option key={item.stateId} value={item.stateId}>
                                    {item.name}
                                 </option>
                              ))}
                           </select>
                        </label>
                        <label className='estimate__locataion-label'>
                           <p className='estimate__locataion-text'>شهر</p>
                           <select
                              name='pets'
                              id='pet-select'
                              className='estimate__locataion-select'
                              value={citiesId.origin}
                              onChange={handleGetStates}
                              disabled={stateOrigin === ''}
                           >
                              <option hidden>انتخاب...</option>
                              {locations.map((item) => (
                                 <option key={item.id} value={item.id}>
                                    {item.name}
                                 </option>
                              ))}
                           </select>
                        </label>
                     </label>
                     {/* مقصد  */}
                     <label className='estimate__locataion-labels'>
                        <p className='estimate__locataion-title'>مقصد</p>
                        <label className='estimate__locataion-label'>
                           <p className='estimate__locataion-text'>استان</p>
                           <select
                              name='stateDes'
                              className='estimate__locataion-select'
                              onChange={handleGetCityes}
                              disabled={citiesId.origin === ''}
                           >
                              <option hidden>انتخاب...</option>
                              {statesDes.map((item) => (
                                 <option key={item.stateId} value={item.stateId}>
                                    {item.name}
                                 </option>
                              ))}
                           </select>
                        </label>

                        <label className='estimate__locataion-label'>
                           <p className='estimate__locataion-text'>شهر</p>
                           <select
                              name='desCity'
                              className='estimate__locataion-select'
                              value={citiesId.destination}
                              onChange={(e) =>
                                 setCitiesId({ ...citiesId, destination: e.target.value })
                              }
                              disabled={citiesDes.length === 0}
                           >
                              <option hidden>انتخاب...</option>
                              {citiesDes.map((item) => (
                                 <option key={item.id} value={item.id}>
                                    {item.name}
                                 </option>
                              ))}
                           </select>
                        </label>
                     </label>

                     <label className='estimate__locataion-label '>
                        <p className='estimate__locataion-text estimate__locataion-text--delivery'>
                           نوع تحویل
                        </p>
                        <select
                           className='estimate__locataion-select'
                           value={delivery}
                           onChange={(e) => setDelivery(Number(e.target.value))}
                        >
                           <option hidden>انتخاب...</option>
                           <option value={1}>درب به درب</option>
                           <option value={2}>باجه کالاپست شهر مقصد</option>
                        </select>
                     </label>
                  </div>

                  <div className='estimate__option'>
                     <h2 className='estimate__option-title'>مشخصات کالا</h2>
                     <div className='estimate__option-content'>
                        <div className='estimate__option-section'>
                           <label className='estimate__option-label estimate__option-label--insu'>
                              بیمه شود
                           </label>
                           <ToggleButton
                              inactiveLabel={''}
                              activeLabel={''}
                              colors={{
                                 inactiveThumb: {
                                    base: '#f8f7f8',
                                 },
                                 activeThumb: {
                                    base: '#fe5900',
                                 },
                                 inactive: {
                                    base: '#edecef',
                                    hover: '#edecef',
                                 },
                                 active: {
                                    base: '#4a4752',
                                    hover: '#4a4752',
                                 },
                              }}
                              trackStyle={styles.trackStyle}
                              thumbStyle={styles.thumbStyle}
                              thumbAnimateRange={[0, 36]}
                              value={assu.stat}
                              onToggle={() => setAssu({ ...assu, stat: !assu.stat })}
                           />
                        </div>
                        <div
                           className='estimate__info-section estimate__info-section-option'
                           style={!assu.stat ? { filter: 'opacity(0.5)' } : null}
                        >
                           <label className='estimate__option-label'>ارزش کالا</label>
                           <input
                              className='estimate__option-input'
                              type='text'
                              readOnly={assu.stat ? false : true}
                              value={assu.value || ''}
                              onKeyDown={(evt) =>
                                 (evt.key === 'e' && evt.preventDefault()) ||
                                 (evt.key === '+' && evt.preventDefault()) ||
                                 (evt.key === '-' && evt.preventDefault())
                              }
                              onWheel={(e) => e.target.blur()}
                              onChange={(e) => setAssu({ ...assu, value: Number(e.target.value) })}
                           />
                        </div>
                     </div>
                  </div>

                  <div className='estimate__info-goods'>
                     <h4 className='estimate__info-title'>مشخصات کالا</h4>
                     <div className='estimate__info-container'>
                        <div className='estimate__info-section'>
                           <label className='estimate__info-lable'>عنوان</label>
                           <input
                              className='estimate__info-input'
                              type='text'
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                           />
                           {/* {validator.current.message(
                  "title",
                  title,
                  "required|titleValid|min:2"
                )} */}
                        </div>
                        <div className='estimate__info-section'>
                           <label className='estimate__info-lable'>نوع</label>
                           <select
                              className='estimate__info-select estimate__info-select-option'
                              onChange={handleChangeType}
                              value={typeAndSize?.title ?? ''}
                           >
                              <option value='' hidden>
                                 انتخاب...
                              </option>
                              {predata?.packSizePackages?.map((item) => (
                                 <option value={item.title} key={item.id}>
                                    {item.id === 0
                                       ? 'سایر'
                                       : `${item.title} ${'  '}${item.height}*${item.width}*${
                                            item.length
                                         }`}
                                 </option>
                              ))}
                           </select>
                           {/* {validator.current.message(
                  "typeAndSize",
                  predata.title,
                  "required"
                )}*/}
                        </div>
                        <div className='estimate__info-section'>
                           <label className='estimate__info-lable'>وزن</label>
                           <input
                              className='estimate__info-input'
                              type='text'
                              value={weight || ''}
                              onChange={(e) => {
                                 const enVal = toEnglishNumbers(e.target.value + '');
                                 setWeight(enVal);
                              }}
                              onKeyDown={canTypeForNumInput}
                           />
                           {/* {validator.current.message("weight", weight, "required")} */}
                        </div>

                        <div className='estimate__info-section'>
                           <label className='estimate__info-lable'>تعداد</label>
                           <input
                              className='estimate__info-input'
                              type='text'
                              value={number || ''}
                              onChange={(e) => {
                                 const enVal = toEnglishNumbers(e.target.value + '');
                                 setNumber(enVal);
                              }}
                              onKeyDown={canTypeForNumInput}
                           />
                           {/* {validator.current.message("number", number, "required")} */}
                        </div>

                        <div className='estimate__info-section'>
                           <label>شکستنی</label>
                           <ToggleButton
                              inactiveLabel={''}
                              activeLabel={''}
                              colors={{
                                 inactiveThumb: {
                                    base: '#f8f7f8',
                                 },
                                 activeThumb: {
                                    base: '#fe5900',
                                 },
                                 inactive: {
                                    base: '#edecef',
                                    hover: '#edecef',
                                 },
                                 active: {
                                    base: '#4a4752',
                                    hover: '#4a4752',
                                 },
                              }}
                              trackStyle={styles.trackStyle}
                              thumbStyle={styles.thumbStyle}
                              thumbAnimateRange={[0, 36]}
                              // thumbIcon={<ThumbIcon />}
                              value={isFragile}
                              onToggle={(e) => setIsFragile(!isFragile)}
                           />
                        </div>

                        <div className='estimate__info-section'>
                           <button className='btn btn--Primary' onClick={handleAdd}>
                              افزودن
                              <img
                                 title='افزودن کالا'
                                 className='progresstabs__content-add-img'
                                 src='./img/plus.svg'
                                 alt='plus'
                              />
                           </button>
                        </div>
                     </div>

                     {packes.length !== 0 && (
                        <ul className='estimate__info-goods-list'>
                           {packes?.map((item, index) => {
                              return (
                                 <li key={index} className='estimate__info-goods-item'>
                                    <p>{item.title}</p>
                                    <p>
                                       {`${item.typeAndSize.size?.height}*${item.typeAndSize.size?.length}*${item.typeAndSize.size?.width}`}
                                    </p>
                                    <p>{item.weight} کیلوگرم</p>
                                    <p>{item.number} عدد</p>
                                    <p>{item.isFragile ? 'شکستنی' : '----'}</p>
                                    <p onClick={() => handleDelete('goodsInfo', index)}>
                                       <img src='/img/delete.png' alt='' />
                                    </p>
                                 </li>
                              );
                           })}
                        </ul>
                     )}
                  </div>

                  <div className='estimate__info-content' style={{ minHeight: '270px' }}>
                     <h1 className='estimate__info-title'>اقلام بسته بندی</h1>
                     <div className='estimate__info-container'>
                        <div className='estimate__info-section estimate__info-section-part'>
                           <label className='estimate__info-lable'>نوع</label>
                           <select
                              className='estimate__info-select'
                              value={type}
                              onChange={handlePackingType}
                           >
                              {/* <option value="" selected hidden> */}
                              <option hidden>انتخاب...</option>
                              {predata?.packSizePackages?.map((item) => (
                                 <option key={item.id} value={item.id}>
                                    {item.title}
                                 </option>
                              ))}
                           </select>
                        </div>

                        <div className='estimate__info-section estimate__info-section-part'>
                           <label className='estimate__info-lable'>تعداد</label>
                           <input
                              className='estimate__info-input'
                              type='text'
                              value={count || ''}
                              onChange={(e) => {
                                 const enVal = toEnglishNumbers(e.target.value + '');

                                 setCount(enVal);
                              }}
                              onKeyDown={canTypeForNumInput}
                           />
                        </div>

                        <div className='estimate__info-section estimate__info-section-btn'>
                           <button className='btn btn--Primary' onClick={handlePacking}>
                              افزودن
                              <img
                                 title='افزودن کالا'
                                 className='progresstabs__content-add-img'
                                 src='./img/plus.svg'
                                 alt='plus'
                              />
                           </button>
                        </div>
                     </div>
                     {packing.length !== 0 && (
                        <ul className='estimate__info-content-list'>
                           {packing.map((item, index) => {
                              return (
                                 <div key={index} className='progresstabs__content-calc-item'>
                                    <p>{item.typeName}</p>
                                    <p>{item.count} عدد</p>
                                    <img
                                       src='./img/delete.png'
                                       alt=''
                                       onClick={() => handleDelete('equipment', index)}
                                    />
                                 </div>
                              );
                           })}
                        </ul>
                     )}
                  </div>
               </div>

               <div className='estimate__option-botton'>
                  <button className='btn btn--secondary' onClick={handleInquiry}>
                     استعلام
                  </button>
               </div>
            </div>
         </main>
      </>
   );
};

export default EstimatedPrice;
